// extracted by mini-css-extract-plugin
module.exports = {"main-component":"lineChartWithDot_main-component__44ud4","layer1":"lineChartWithDot_layer1__1xDTY","layer2":"lineChartWithDot_layer2__S2gIH"};